import './static/fonts/fonts.css';
import './static/plyr.css';
